/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import router from '@/router';
// services for new API
import apiLayer from '@/services/jApiLayer';

const state = {
  layer_detail: null,
  layer_created: false,
  layer_updated: false,
  layer_deleted: false,
};

const mutations = {
  getDetailLayer(state, payload) {
    state.layer_detail = payload.data;
  },

  createLayer(state) {
    state.layer_created = !state.layer_created;
  },

  updateLayer(state) {
    state.layer_updated = !state.layer_updated;
  },

  deleteLayer(state) {
    state.layer_deleted = !state.layer_deleted;
    router.push('/administrator/layer');
  },
};

const actions = {
  // detail layer
  async getDetailLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const detailLay = await apiLayer.getDetailLayer(data);
      commit('getDetailLayer', detailLay);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // get list parent
  async getListParent({ dispatch }, { reqData, callback }) {
    try {
      const listParent = await apiLayer.getListParent(reqData);
      const res = listParent.data;
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // create layer
  async createLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const createLay = await apiLayer.createLayer(data);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', createLay.message, { root: true });
      commit('createLayer');
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // detail layer
  async updateLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const updateLay = await apiLayer.updateLayer(data);
      commit('updateLayer');
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', updateLay.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // delete layer
  async deleteLayer({ dispatch, commit }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const deleteLay = await apiLayer.deleteLayer(data);
      commit('deleteLayer');
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', deleteLay.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreLayer.js